import { Observable } from 'rxjs';
import { Parameter } from '../../../../../@core/interfaces/common/parameter';

export interface QualityTeamParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface QualityTeam {
  id?:number;
  qualityTeamName:string;
warehouseId:number;
  createdBy:number;
  createdDate:Date
  updatedBy:number;
  updatedDate:Date
  tenantId:any;
  createdIP:string;
  updatedIP:string;
    
  parameters?: QualityTeamParameter[];
  links?: any;
}

export abstract class QualityTeamData { 
  abstract list(url: string): Observable<QualityTeam[]>;
  abstract create(url: string,data: QualityTeam): Observable<any>;
  abstract update(url: string,data: QualityTeam): Observable<any>;
  abstract delete(url: string): Observable<any>;
}